import http from "../../services/http-common";

class ProjectionPlanningService {
  getProjectionPlanningUpperData(fabricContractID) {
    return http.get(`/projectionPlanning/upperData/${fabricContractID}`);
  }
  insert(data) {
    return http.post(`/projectionPlanning/insert`,data);
  }
  getProjection(companyID , fabricQualityID) {
    return http.get(`/projectionPlanning/FristGrid/${companyID}/${fabricQualityID}`);
  }
  getBelowProjection(id) {
    return http.get(`/projectionPlanning/belowGrid/${id}`);
  }


}

export default new ProjectionPlanningService();
